import BillingCyclePopup from './BillingCyclePopup';
import BillingCyclePopupContainer from './BillingCyclePopup.container';

export default BillingCyclePopupContainer(BillingCyclePopup);
